module.exports = __webpack_public_path__ + "img/MP Portal Banner.75126e79.png";